import { render, staticRenderFns } from "./examList.vue?vue&type=template&id=67ce1006&scoped=true"
import script from "./examList.vue?vue&type=script&lang=js"
export * from "./examList.vue?vue&type=script&lang=js"
import style0 from "./examList.vue?vue&type=style&index=0&id=67ce1006&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67ce1006",
  null
  
)

export default component.exports